/* US cart drawer delivery date: eight local calendar days, including weekends. */
(() => {
  'use strict';
  if (window.__lbdbCartUSDeliveryInitialized) return;
  window.__lbdbCartUSDeliveryInitialized = true;

  let drawer;
  let observer;
  const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });

  function update() {
    if (!drawer || !drawer.isConnected) return;
    const expected = new Date();
    expected.setDate(expected.getDate() + 8);
    const label = formatter.format(expected);
    const iso = `${expected.getFullYear()}-${String(expected.getMonth() + 1).padStart(2, '0')}-${String(expected.getDate()).padStart(2, '0')}`;
    drawer.querySelectorAll('[data-cart-footer-delivery]').forEach(block => {
      const time = block.querySelector('[data-cart-delivery-date]');
      if (!time) return;
      if (time.textContent !== label) time.textContent = label;
      if (time.getAttribute('datetime') !== iso) time.setAttribute('datetime', iso);
      if (block.hidden) block.hidden = false;
    });
  }

  function connect() {
    const current = document.querySelector('#cart-drawer');
    if (current !== drawer) {
      if (observer) observer.disconnect();
      drawer = current;
      if (drawer) {
        observer = new MutationObserver(update);
        observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
      }
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('cart:change', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) connect(); });
  window.addEventListener('focus', connect);
  window.addEventListener('pageshow', connect);
})();
